const LoadQuoteModal = r => require.ensure([], () => r(require('./LoadQuoteModal.vue')), 'loadquotesteps')
const LoadQuoteSteps = r => require.ensure([], () => r(require('./LoadQuoteSteps.vue')), 'loadquotesteps')

const Steps = {
  CreateAssign: { id: 1, enabled: true },
  GotoQuote: { id: 2, enabled: true }
}

export { LoadQuoteModal, LoadQuoteSteps, Steps }
